var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTauxEng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_953_6686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.0001H15M4.99999 10.0001H1.66666M9.99999 5.00008V1.66675M9.99999 18.3334V15.0001M16.6667 10.0001C16.6667 13.682 13.6819 16.6667 9.99999 16.6667C6.31809 16.6667 3.33332 13.682 3.33332 10.0001C3.33332 6.31818 6.31809 3.33341 9.99999 3.33341C13.6819 3.33341 16.6667 6.31818 16.6667 10.0001ZM12.5 10.0001C12.5 11.3808 11.3807 12.5001 9.99999 12.5001C8.61928 12.5001 7.49999 11.3808 7.49999 10.0001C7.49999 8.61937 8.61928 7.50008 9.99999 7.50008C11.3807 7.50008 12.5 8.61937 12.5 10.0001Z",
    stroke: "#7F56D9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_953_6686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTauxEng);
export default __webpack_public_path__ + "static/media/icon_taux_eng.408ef9ca04d8ac9737d1da600e34e832.svg";
export { ForwardRef as ReactComponent };